import { render, staticRenderFns } from "./OnboardingStepInvitacionEnviada.vue?vue&type=template&id=5bb71cf7"
import script from "./OnboardingStepInvitacionEnviada.vue?vue&type=script&lang=js"
export * from "./OnboardingStepInvitacionEnviada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports